import getuser from '../aws_utils/getAuthuser';
import { addProjectChat } from '../apigateway/mongocalls';
import { invokeQueryImageAgentApi } from '../apigateway/agentcalls';


export default async function invokeimageagent(query, imgData, projectname) {


let userid = ""
try {
    const user = await getuser()
    userid = user.username
    
} catch (error) {
    console.log(error)
}
// console.log("User Id", userid)

    // let images = [{}];
    const images = imgData.documents_selected // [{data, key, type}]

    // console.log('query', query);
    // console.log('imgdata', imgData); // {documents_selecetd: [{}]}
    // console.log('projectname', projectname);


    try {


        // if(images.length >= 2){
        // // console.log("More than 1 image")
        // // console.log("Images", images)
        // }

        // Invoke Lambda Itself
        // const config = {
        //     region: 'us-east-1',
        //     credentials: {
        //         accessKeyId: process.env.REACT_APP_REALM_AWSID,
        //         secretAccessKey: process.env.REACT_APP_REALM_AWSKEY
        // }}
        // const client = new LambdaClient(config);
        // // console.log("Client", client)

        // const input = { // InvocationRequest
        //   FunctionName: "arn:aws:lambda:us-east-1:457968394077:function:imageagent", // required
        // //   InvocationType: "Event",
        //   LogType: "Tail",
        // //   ClientContext: "STRING_VALUE",
        //   Payload: JSON.stringify({
        //             "query" : query,
        //             "images" : images,
        //         }),
        // //   Qualifier: "STRING_VALUE",
        // };
        // // console.log("Input", input)
        // const command = new InvokeCommand(input);
        // // console.log("COmmand", command)
        // const response = await client.send(command);
        // // console.log(response)
        // const payloadString = String.fromCharCode.apply(null, response.Payload);
        // // console.log("Lambda Response", payloadString)
        // const respob = JSON.parse(payloadString)
        // const content = respob.body[0].message.content
        // // console.log("Lambda Response", content)
       



        // Invoke Query Image Agent Api
    
        const resp = await invokeQueryImageAgentApi(query, images);
        // console.log('resp', resp)
    

        const addPackage = {
        "project": projectname,
        "userId": userid,
        "query": query,
        "response" : resp,    
        "agent" : "vision agent",
        "images": images, // [{}]
        }
        const result = await addProjectChat(addPackage)

        const output = {
            "result": result,
            "response": resp
        }
        // console.log("output from invoke image agent", output)

        return output
        
      
    } catch (error) {
        console.log("Error invoking query image agent", error)
        return error    
    }

  

    
}
